import { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import { ChevronDarkRightIconFaq } from 'Components';
import './FAQItem.scss';

type FAQItemProps = {
  Question: string;
  Answer: string;
  handleClick: (a: string, q: string) => void;
};

const FAQItem: FC<FAQItemProps> = ({ Answer, Question, handleClick }) => {
  return (

    <li id="faqItem"itemID="faqItem">
      <button 
        onClick={() => handleClick(Answer, Question)} 
      >
        <Typography variant="h6" component="span">
          <Box fontSize="1rem" fontWeight={600}>
            {Question}
          </Box>
        </Typography>
        <Box>
          <ChevronDarkRightIconFaq />
        </Box>
      </button>
    </li>
  );
};
export default FAQItem;
